const NAME = "ABSENT_COLLABORATORS";

export default NAME;
